
export const Theme = {
  placeholer: [
    'relative bg-gray-50 text-sm flex flex-col items-center justify-center gap-2 rounded-lg p-6 cursor-pointer border border-transparent aspect-video h-[160px]',
    'hover:bg-gray-100',
    'dark:bg-gray-700 dark:border-gray-600',
    'dark:hover:bg-gray-600'
  ],
  placeholerError: 'border-danger'
}
